import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { OrderPage } from 'Store/Order/enums';
import { fetchClearOrder } from 'Store/Order/thunks';
import { getOrderRequest } from 'Store/Order/selectors';
import OrderStartPage from 'Pages/OrderStartPage/OrderStartPage';

import { 
  getIsFetching, 
  getIsFetchFailed, 
  getIsInvalidOrderItem, 
  getIsOpenForSale, 
  getStartSaleDate,
} from 'Components/OrderItem/Redux/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isFetchFailed: boolean;
  isInvalidOrderItem: boolean;
  isOpenForSale: boolean;
  startSaleDate: Date;
  orderRequest: Julius.Website.OrderRequestViewModel;
  fetchClearOrder: () => void;
}

type Props = IPropsInternal & RouteComponentProps<{ orderItemID: string }>;

class OrderStartPageContainer extends React.PureComponent<Props> {

  componentWillMount() {
    this.props.fetchClearOrder();
  }

  onPickSeatsManually = () => {
    this.redirectTo(OrderPage.SEAT_PICKER);
  }

  onPickSeatsAutomatically = () => {
    this.redirectTo(OrderPage.DETAILS);
  }

  redirectTo = (page: string) => {
    const { history, match: { params: { orderItemID } } } = this.props;
    history.replace(`/order/${ orderItemID }${ page }`);
  }

  render() {

    const { isOpenForSale, startSaleDate } = this.props;
    const isOpeningSoon = !isOpenForSale && startSaleDate && 
      startSaleDate.getTime() > new Date().getTime();

    return (
      <OrderStartPage 
        isFetching={ this.props.isFetching }
        isFetchFailed={ this.props.isFetchFailed }
        isOpenForSale={ isOpenForSale }
        isOpeningSoon={ isOpeningSoon }
        isInvalidOrderItem={ this.props.isInvalidOrderItem }
        startSaleDate={ startSaleDate }
        onPickSeatsManually={ this.onPickSeatsManually }
        onPickSeatsAutomatically={ this.onPickSeatsAutomatically }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    isFetchFailed: getIsFetchFailed(state),
    isInvalidOrderItem: getIsInvalidOrderItem(state),
    isOpenForSale: getIsOpenForSale(state),
    startSaleDate: getStartSaleDate(state),
    orderRequest: getOrderRequest(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchClearOrder,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(OrderStartPageContainer);


// WEBPACK FOOTER //
// ./src/pages/OrderStartPage/OrderStartPageContainer.tsx